// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "../v2/Skillet.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "./TupperwareLayoutSwitch.res.mjs";
import * as PilotClozeDragBucketDisplay$LiteracyplanetTupperware from "./PilotClozeDragBucketDisplay.res.mjs";

function SkilfulClozeDragBucketDisplay(props) {
  var children = props.children;
  if (Curry._1(TupperwareLayoutSwitch$LiteracyplanetTupperware.use, undefined) === "Pilot") {
    return React.createElement(PilotClozeDragBucketDisplay$LiteracyplanetTupperware.make, {
                children: children
              });
  } else {
    return React.createElement("div", {
                className: Skillet$LiteracyplanetTupperware.SkilfulClozeDragBucketDisplay.className
              }, children);
  }
}

var make = SkilfulClozeDragBucketDisplay;

var $$default = SkilfulClozeDragBucketDisplay;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
